import variables from "@/_styles/variables.module.scss"

import { IProvider } from "./IProvider"

import { IDriver } from "@/types/IDriver"


export interface IOrderAuthorities {
  orderId: number,
  orderNumber: string,
  customerName: string
}

export interface IAuthorities {
  id: number
  number: string
  date: Date
  orderAuthorities: IOrderAuthorities
  driver: IDriver
  providerId: number
  provider: IProvider
  issuedName?: string
}

export interface IAuthoritiesCreate {
  number: string
  date: Date
  orderId: number
  driverId: number
  newDrivers: IDriver[]
  providerId: number
}

export interface IAuthoritiesUpdate extends IAuthoritiesCreate {
  id: number
}

export interface IAuthorityLogs {
  id: number
  authorityNumber: string
  dateTime: Date
  status: number
  statusText: string
  storageKey: string
}

export const LogStatusColors: Record<number, string> = {
  0: variables.statusGreenColor,  // Данные доступны
  1: variables.statusRedColor,    // Данные с ошибкой
  2: variables.statusOrangeColor  // Данные не найдены
}

export const AUTHORITIES_KEY = "AUTHORITIES_KEY"
export const AUTHORITY_LOGS_KEY = "AUTHORITY_LOGS_KEY"